module.exports = __webpack_public_path__ + "static/media/sun-haze.85f35f5b.svg";